import { SuperAdminScope } from 'src/components';
import { usePageHeader } from 'src/hooks/misc';
import { RuleEditorModal } from './components/RuleEditorModal';
import { MagicFlowAdminTabs } from './components/MagicFlowAdminTabs';
import { MagicFlowOrgSelector } from './components/MagicFlowOrgSelector';
import { useMagicFlowAdminController } from './useMagicFlowAdminController';

const MagicFlowAdminContent = () => {
  const {
    activeTab,
    onTabChange,
    hasOrgSelected,
    addRuleRow,
    ruleRows,
    ruleEditorColumns,
    isLoadingCurrentRuleSet,
    isFetchingCurrentRuleSet,
    hasUnsavedRuleChanges,
    isSavingRuleSet,
    handleSaveRuleSet,
    openCreateTemplate,
    workflowTemplateTableData,
    templateColumns,
    isLoadingTemplates,
    isFetchingTemplates,
    namespace,
    setNamespace,
    eventName,
    setEventName,
    eventId,
    setEventId,
    eventDataJson,
    setEventDataJson,
    namespaceOptions,
    isLoadingNamespaces,
    hasPublishErrors,
    isPublishingEvent,
    handlePublishEvent,
    ruleSetRuns,
    isLoadingRuleSetRuns,
    isFetchingRuleSetRuns,
    refreshRuleSetRuns,
    ruleDetailModal,
    closeRuleDetailModal,
    editingRule,
    updateRuleRow,
    ruleActionTypeOptions,
    currentActionInputs,
    setCurrentActionInputField,
    templateOptions,
    templateOverrideOptions,
    priorityOptions,
    actionInputsError,
    conditionsError,
    additionalInputsDraft,
    setAdditionalInputsDraft,
    additionalInputsError,
    parseJson,
  } = useMagicFlowAdminController();

  usePageHeader({
    title: 'Magicflow Studio',
  });

  return (
    <div className="page-wrapper">
      <MagicFlowOrgSelector
        hasOrgSelected={hasOrgSelected}
        disableSelector={activeTab === 'workflow-templates'}
      />

      <MagicFlowAdminTabs
        activeTab={activeTab}
        onTabChange={onTabChange}
        hasOrgSelected={hasOrgSelected}
        onAddRule={addRuleRow}
        ruleRows={ruleRows}
        ruleEditorColumns={ruleEditorColumns}
        isLoadingCurrentRuleSet={isLoadingCurrentRuleSet}
        isFetchingCurrentRuleSet={isFetchingCurrentRuleSet}
        hasUnsavedRuleChanges={hasUnsavedRuleChanges}
        isSavingRuleSet={isSavingRuleSet}
        onSaveRuleSet={handleSaveRuleSet}
        onCreateTemplate={openCreateTemplate}
        workflowTemplateTableData={workflowTemplateTableData}
        templateColumns={templateColumns}
        isLoadingTemplates={isLoadingTemplates}
        isFetchingTemplates={isFetchingTemplates}
        namespace={namespace}
        setNamespace={setNamespace}
        eventName={eventName}
        setEventName={setEventName}
        eventId={eventId}
        setEventId={setEventId}
        eventDataJson={eventDataJson}
        setEventDataJson={setEventDataJson}
        namespaceOptions={namespaceOptions}
        isLoadingNamespaces={isLoadingNamespaces}
        hasPublishErrors={hasPublishErrors}
        isPublishingEvent={isPublishingEvent}
        onPublishEvent={handlePublishEvent}
        ruleSetRunsTableData={ruleSetRuns.map((run, index) => ({
          ...run,
          key: String(
            run.rule_set_run_id || run.event_id || run.updated_at || index
          ),
        }))}
        isLoadingRuleSetRuns={isLoadingRuleSetRuns}
        isFetchingRuleSetRuns={isFetchingRuleSetRuns}
        onRefreshRuleSetRuns={refreshRuleSetRuns}
      />

      <RuleEditorModal
        open={ruleDetailModal.open}
        editingRule={editingRule}
        onClose={closeRuleDetailModal}
        onUpdateRuleRow={updateRuleRow}
        ruleActionTypeOptions={ruleActionTypeOptions}
        currentActionInputs={currentActionInputs}
        setCurrentActionInputField={setCurrentActionInputField}
        templateOptions={templateOptions}
        templateOverrideOptions={templateOverrideOptions}
        priorityOptions={priorityOptions}
        actionInputsError={actionInputsError}
        conditionsError={conditionsError}
        additionalInputsDraft={additionalInputsDraft}
        setAdditionalInputsDraft={setAdditionalInputsDraft}
        additionalInputsError={additionalInputsError}
        parseJson={parseJson}
      />
    </div>
  );
};

const MagicFlowAdminPage = () => (
  <SuperAdminScope>
    <MagicFlowAdminContent />
  </SuperAdminScope>
);

export default MagicFlowAdminPage;
